import '../styles/index.css';

export interface SpeakerIntroProps {
  speakerId: string;
  displayName: string;
}

export function SpeakerIntro({ speakerId, displayName }: SpeakerIntroProps) {
  return (
    <div className="pawa-speaker-container pawa-chat-item" data-speaker-id={speakerId}>
      <div className="pawa-speaker-badge">
        <span className="pawa-speaker-icon">✨</span>
        <span className="pawa-speaker-name">{displayName} entered</span>
      </div>
    </div>
  );
}
